import { createStructuredSelector, createSelector } from 'reselect'

export const fromState = (value) => (state = {}) => state[value]
export const fromProps = (value) => (state = {}, prop = {}) => prop[value]

export const selectorFromKeys = (keys, fn = fromState) => {
    return createStructuredSelector(
        keys.reduce((acc, key) => {
            if (typeof key === 'string') {
                acc[key] = fn(key)
            } else if (typeof key === 'object') {
                return { ...acc, ...key }
            }
            return acc
        }, {})
    )
}

export const mergeSelectorKeys = (...selectors) => {
    return createSelector(
        ...selectors,
        (...results) => {
            return results.reduce((acc, result) => {
                return { ...acc, ...result }
            }, {})
        }
    )
}

export const createCombinedSelector = ({ name, state = [], props = [], fn, passThroughState = [] }) => {
    const stateSelector = selectorFromKeys(state)
    const propsSelector = selectorFromKeys(props, fromProps)
    const selector = mergeSelectorKeys(
        createSelector(
            stateSelector,
            propsSelector,
            fn
        ),
        selectorFromKeys(passThroughState)
    )
    return selector
}
